import React, {
  forwardRef,
  useContext,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import AppLoader from "../../components/loader/loader";
import { changePassword } from "../../services/authFn";
import CustomSnackbar from "../../components/customSnackBar/customSnackBar";
import AppContext from "../../components/context/appContext";

const ChangePasswordDialog = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const snackRef = useRef(null);
  const { user } = useContext(AppContext);
  console.log(user, "userkdjlskj");
  console.log(user?.id, "userkdjlskj");
  useImperativeHandle(ref, () => ({
    openDialog: () => setOpen(true),
    closeDialog: () => setOpen(false),
  }));

  const handleOpenSnack = (status, message) => {
    if (snackRef.current) {
      snackRef.current.isOpenSnack({
        snackType: status,
        snackMessage: message,
      });
    }
  };

  const handleSubmit = async () => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      handleOpenSnack("error", "Please fill all fields");
      return;
    }

    if (newPassword !== confirmPassword) {
      handleOpenSnack("error", "New password and confirm password do not match");
      return;
    }

    if (newPassword.length < 6) {
      handleOpenSnack("error", "Password must be at least 6 characters long");
      return;
    }

    const payload = {
      userId: user?.id,
      currentPassword,
      newPassword,
      confirmPassword,
    };
    setLoading(true);
    try {
      const response = await changePassword(payload);
      console.log(response, "responsessss");
      if (response?.status === 200 || response?.status === 201) {
        handleOpenSnack("success", response?.data?.message);
        setOpen(false);
      } else {
        handleOpenSnack("error", response?.data?.message);
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <AppLoader isVisible={loading} />
      <DialogTitle>Change Password</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Current Password"
          type={showCurrentPassword ? "text" : "password"}
          fullWidth
          variant="outlined"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          helperText="Enter your current password"
          InputProps={{
            style: { backgroundColor: "#f5f5f5" },
            endAdornment: (
              <IconButton
                onClick={() => setShowCurrentPassword(!showCurrentPassword)}
              >
                {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ),
          }}
        />
        <TextField
          margin="dense"
          label="New Password"
          type={showNewPassword ? "text" : "password"}
          fullWidth
          variant="outlined"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          helperText="Choose a strong password"
          InputProps={{
            style: { backgroundColor: "#f5f5f5" },
            endAdornment: (
              <IconButton onClick={() => setShowNewPassword(!showNewPassword)}>
                {showNewPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ),
          }}
        />
        <TextField
          margin="dense"
          label="Confirm New Password"
          type={showConfirmPassword ? "text" : "password"}
          fullWidth
          variant="outlined"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          helperText="Re-enter your new password"
          required
          InputProps={{
            style: { backgroundColor: "#f5f5f5" },
            endAdornment: (
              <IconButton
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ),
          }}
        />
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "right" }}>
        <Button
          sx={{ width: "100px" }}
          onClick={handleClose}
          color="secondary"
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          sx={{
            backgroundColor: "primary.light",
            width: "100px",
            color: "white",
            "&:hover": { backgroundColor: "primary.light" },
          }}
          variant="contained"
        >
          Submit
        </Button>
      </DialogActions>
      <CustomSnackbar ref={snackRef} />
    </Dialog>
  );
});

export default ChangePasswordDialog;
